import { client } from "api";

export type RemoveUserFromCompanyRequest = {
  companyId: string;
  userId: string;
};

export type RemoveUserFromCompanyResponse = string;

export const removeUserFromCompany = ({ companyId, userId }: RemoveUserFromCompanyRequest) =>
  client
    .delete<RemoveUserFromCompanyResponse>(`/company/${companyId}/users/${userId}`)
    .then((res) => res.data);
